import { IResponse } from '@microsoft/portal-app/lib/ajax-utils';
import { IAjaxCreationMethod, IAjaxRequest } from '@microsoft/portal-app/lib/auth';
import { getMsGraphUrl } from '@microsoft/portal-app/lib/ms-graph-api/getMsGraphUrl';
import { IPrivacyProfile } from '@microsoft/portal-app/lib/Organization/models/IOrganization';
import { addAjaxEpic, getSuccessActionType } from '@microsoft/portal-app/lib/redux/createAjaxEpic';
import { map } from 'rxjs/operators';
import { IPrivacyAction, IPrivacyProfileResponse, IPrivacyState, PrivacyActions } from '../../models';
import { privacyRegistry } from '../privacyRegistry';
import { getMSGraphScopeAndEndPoint } from '../../../shared/utils';
import { MSGraphScopes } from '../../../shared/constants';

const getPrivacyStatementUrl = getMsGraphUrl();
export const getPrivacyStatementAjax = (ajax: IAjaxCreationMethod) => {
  return ajax.getJSON<IPrivacyProfile>(getPrivacyStatement()).pipe(
    map(response => {
      return { response };
    })
  );
};

export const getPrivacyStatement = () =>
  ({
    url: getPrivacyStatementUrl('/organization?', '$select=privacyProfile').toString(),
    audience: getMSGraphScopeAndEndPoint(MSGraphScopes.OrganizationReadAll).scope,
  } as IAjaxRequest);

export const getPrivacyStatementSuccess = (
  state: IPrivacyState,
  action: IPrivacyAction<IResponse<IPrivacyProfileResponse>>
): IPrivacyState => {
  const privacyStatement =
    action.payload &&
    action.payload.response &&
    action.payload.response.value[0] &&
    action.payload.response.value[0].privacyProfile &&
    action.payload.response.value[0].privacyProfile.statementUrl;

  if (privacyStatement === null || privacyStatement === undefined || privacyStatement === '') {
    return state;
  }

  return {
    ...state,
    privacyStatement: privacyStatement
  };
};

addAjaxEpic(privacyRegistry, PrivacyActions.getPrivacyStatement, getPrivacyStatementAjax, {
  showErrorAsToast: true,
  errorMessage: {
    key: 'unexpectedPrivacyStatementError',
    options: {
      ns: 'Privacy'
    }
  }
});

privacyRegistry.add(getSuccessActionType(PrivacyActions.getPrivacyStatement), getPrivacyStatementSuccess);
